import { ONLINE_CHECK_IN } from '@eti/products';
import type { AvailableExtraProductsType } from '../../../../models';

export const isCheckInProductAvailableToBuy = (products: AvailableExtraProductsType) =>
  products ? products.some((product) => Number(product?.id) === ONLINE_CHECK_IN.id) : false;
